import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  position: relative;
  width: 500px;
`;

const Background = styled.div`
  position: relative;
  height: 11px;
  background-color: #ffffff1a;

  &:before {
    content: ' ';
    position: absolute;
    width: calc(100% + 4px);
    height: calc(100% + 4px);
    box-shadow: 0 0 0 1px hsl(0deg 0% 100% / 20%);
    transform: translate(-2px, -2px);
    left: 0;
    top: 0;
  }
`;

const Foreground = styled.div`
  width: ${(props) => `${props.progress}%`};
  height: 100%;
  background-color: #fffc;
  transition: width 0.3s;
`;

const Value = styled.div`
  margin-bottom: 12px;
  color: #fff9;
  user-select: none;
  cursor: default;
  display: flex;

  div {
    padding-right: 30px;
    position: relative;
  }

  div:not(:last-child):after {
    content: '/';
    position: absolute;
    right: 12px;
    white-space: pre-wrap;
    color: #fff6;
    pointer-events: none;
  }
`;

const getPercentage = (current, total) => {
  if (total === 0) return 0;
  return Math.round((current / total) * 1000) / 10;
};

export default function Progress({ current, total }) {
  const progress = getPercentage(current, total);

  return (
    <Wrapper>
      <Value>
        <div>
          {current}/{total}
        </div>
        <div>{progress}%</div>
      </Value>
      <Background>
        <Foreground progress={progress} />
      </Background>
    </Wrapper>
  );
}
